import { render } from "./CategoryInput.vue?vue&type=template&id=409e86e4&scoped=true"
import script from "./CategoryInput.vue?vue&type=script&lang=js"
export * from "./CategoryInput.vue?vue&type=script&lang=js"

import "./CategoryInput.vue?vue&type=style&index=0&id=409e86e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409e86e4"]])

export default __exports__